<template>
  <div class="acknowledgements">
    <bModal :showModal.sync='modalStatus' :content.sync="content" :checkboxTxt.sync="checkboxTxt" @controlModal="controlModalFn"></bModal>
    <p v-html="$t('headerMsg.acknowledgements')"></p>
    <p v-html="$t('Acknowledgements.age')"></p>
    <p v-html="$t('Acknowledgements.message')"></p>
    <p v-html="$t('Acknowledgements.receive.text')"></p>
    <ul class="terms-list">
        <li v-for="(item,index) in $t('Acknowledgements.receive.list')" v-html='item' :key='index'></li>
    </ul>
    <el-form :model="formData" label-position="top" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item prop="checkList" >
            <el-checkbox-group v-model="formData.checkList" class="checkList">
              <el-checkbox :label="item" :key="index" v-for="(item,index) in termsArr" name="checkList" required="true">{{$t(`Acknowledgements.${item}`)}}</el-checkbox>
            </el-checkbox-group>
            <!-- <el-checkbox v-model="formData.Marketing_Email_Preference">{{$t(`Acknowledgements.Marketing_Email_Preference`)}}</el-checkbox> -->
            <div v-html="$t(`Acknowledgements.Marketing_automatically`)"></div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-show="!routeParamsHasA">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
            <el-form-item :label="$t('Acknowledgements.Hear_ATFX')" prop="Hear_ATFX">
              <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Hear_ATFX" class="select-width" :placeholder="$t('messages.unSelect')">
                <el-option v-for="(item,index) in $t('Acknowledgements.hearATFXSelect')" :key="index" :label="item" :value="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-show="formData.Hear_ATFX=='Other'">
            <el-form-item :label="$t('Acknowledgements.OtherHearATFX')" prop="OtherHearATFX">
              <el-input v-model="formData.OtherHearATFX"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Hear_ATFX=='Partnership'">
            <el-form-item :label="$t('Acknowledgements.Rec_Type')" prop="Rec_Type">
              <el-select @visible-change="$elui_Select_Edge"  v-model="formData.Rec_Type" class="select-width" :placeholder="$t('messages.unSelect')">
                <el-option v-for="(item,index) in $t('Acknowledgements.recTypeSelect')" :key="index" :label="item" :value="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="formData.Hear_ATFX=='Partnership'&&formData.Rec_Type!='NAN'">
            <el-form-item :label="$t('Acknowledgements.Parent_IB_Code')" prop="Parent_IB_Code">
              <el-input v-model="formData.Parent_IB_Code"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Bus from './../../util/bus'
export default {
  name: "Experience",
  mixins: [
    require("@/assets/mixin/base.js").base('Acknowledgements')
  ],
  mounted(){
      _g.trackStepPage(6);
    // recodeModel插入 Marketing_Email_Preference
    let Acknowledgements = this.$parent.$parent.recodeModel['Acknowledgements']
    Acknowledgements.unshift('Marketing_Email_Preference');
    Acknowledgements = new Set(Acknowledgements)
  },
  data() {
    const HearATFX = (rule, value, callback) => {
      if (this.routeParamsHasA) return callback();
    /*  if(!['USD'].includes(this.formData.MT4_Currency)) return callback();*/
      // if (!value || value == '') {
      //   return callback(new Error(this.$t("customErrMsg.fieldIsRequired.HearATFX")));
      // }
      callback();
    }
    const OtherHearATFX = (rule, value, callback) => {
      if (this.routeParamsHasA) return callback();
     /* if(!['USD'].includes(this.formData.MT4_Currency)) return callback();*/
      if (this.formData.Hear_ATFX != "Other") return callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.OtherHearATFX")));
      }
      callback()
    }
    const Rec_Type = (rule, value, callback) => {
      if (this.routeParamsHasA) return callback();
    /*  if(!['USD'].includes(this.formData.MT4_Currency)) return callback();*/
      if (this.formData.Hear_ATFX != "Partnership") callback()
      if (!value || value == '') {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Rec_Type")));
      }
      callback()
    }
    const Parent_IB_Code = (rule, value, callback) => {
      if (this.routeParamsHasA) return callback();
  /*    if(!['USD'].includes(this.formData.MT4_Currency)) return callback();*/
      if (this.formData.Hear_ATFX != "Partnership") return callback();
      if (this.formData.Rec_Type=='NAN') return callback();
      if (!(value || value == '')) {
        return callback(new Error(this.$t("customErrMsg.fieldIsRequired.Parent_IB_Code")));
      }
      callback()
    }
    const checkList = (rule, value, callback) => {
      Bus.$on('clickVal', (data)=>{
        this.isClick = data;
        if(this.isClick==true){     
          if (this.formData.checkList.length==this.termsArr.length) return callback()
          return callback(new Error(this.$t("customErrMsg.fieldIsRequired.A1")));
        }
      })
    }
    return {
      termsArr:['checkboxTxt_A1','checkboxTxt_A2','checkboxTxt_A3'],
      rulesArr:[
        {name: "checkList",type: 'checkbox',rules: [{required: true,type: 'checkList',validator:checkList}]},
        {name: "Hear_ATFX",type: "select",rules: [{required: false,validator:HearATFX}]},
        {name: "OtherHearATFX",type: "input",rules: [{required: true,validator:OtherHearATFX},{max: 20}]},
        {name: "Rec_Type",type: "select",rules: [{required: true,validator:Rec_Type}]},
        {name: "Parent_IB_Code",type: "input",rules: [{required: true,validator:Parent_IB_Code},{max: 20}]},
      ],
      USDCurrency:false,
      content:this.$t('ModalMsg.showModal.content'),
      checkboxTxt:this.$t('ModalMsg.showModal.checkboxTxt'),
    };
  },
  computed:{
    rules(){
      return this.$getRules(this.rulesArr);
    },
    routeParamsHasA(){
      return 'a' in this.$route.query
    },
    ...mapState(["modalStatus"]),
  },
  methods: {
    getPageFormData(cb) {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.selectTitle();
          return cb(true);
        } else {
          // return cb(true);
          return cb(false);
        }
      });
    },
    selectTitle() {
      let fields = this.$refs["ruleForm"].fields;
      // 处理OtherHearATFX、Rec_Type、Parent_IB_Code
      if(!this.routeParamsHasA){  // routeParamsHas:true， 代表route有a,保留Rec_Type、Parent_IB_Code值
        let arr=[];
        if(['USD','GBP','EUR'].includes(this.formData.MT4_Currency)){
          if (!['Partnership'].includes(this.formData.Hear_ATFX)) arr.push(...['Rec_Type','Parent_IB_Code']);
          if (!['Other'].includes(this.formData.Hear_ATFX)) arr.push('OtherHearATFX');
          if(['NAN'].includes(this.formData.Rec_Type)) arr.push('Parent_IB_Code');
        }else{
          arr.push('Hear_ATFX','OtherHearATFX','Rec_Type','Parent_IB_Code');
        }
        Util.resetField(arr, fields,this.formData)
      }
    },
     controlModalFn(val){
      //  console.log(val)
      this.$store.commit("SAVEMODALSTATUS", false)
    },
  },
  watch: {
  }
};
</script>

<style lang="scss">
  .el-form-item--small .el-form-item__label,.el-form-item--small .el-form-item__content {
    line-height: normal;
  }
.mobileType {
  .acknowledgements{
    label.el-checkbox{
      white-space: normal;
    }
    .el-checkbox__label{
      display: inline;
      color: black;
    }
  }
}
.pcType {
  .acknowledgements{
     label.el-checkbox{
      width: 100%;
    }
    .el-checkbox__label{
      width: 100%;
    }
  }
}
.acknowledgements {
  margin-left: 16px;
  p{
    margin-top: 10px;
  }
  .terms-list {
    padding-left:20px;
    li{
      line-height:30px;
      &::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #f2672a;
        border-radius: 50%;
        position: relative;
        top: -2px;
        left: -5px;
      }
      a{
        color:#0F2D52
      }
    }
  }
  
  label.el-checkbox{
    margin-left: 0;
    line-height: 25px;
    &[required=required]{
      .el-checkbox__label::before{
        content: '*';
        color: #f2672a;
        position: absolute;
        left:10px;
      }
    }
    .el-checkbox__label{
      padding-left:20px;
      position: relative;
    }
  }
  .select-width{
    width: 100%;
  }
  label.el-checkbox.is-checked .el-checkbox__label{
    color:#000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/steps/acknowledgements.vue